module.exports = {
    SecertKey: 'ae8b3ca9-cb96-4c17-9ed2-bb2374a02e6c',
    RoutUser: '/user/home',
}


// WEBPACK FOOTER //
// ./src/config/index.js